import ReelsToBuy, { MediaItem } from "@/components/ReelsToBuy";
import { useSEO } from "@/hooks/useSEO";
import { useEffect } from "react";
import { BRAND_SITE_URL } from "@/lib/brandConfig";

/**
 * Pack2 Page - Example pack with only images (carousel style)
 *
 * Features:
 * - Shows first 3 images for free (preview)
 * - Horizontal carousel navigation (left/right arrows)
 * - After 3rd image, shows "Buy" button on the right
 */
const Pack2 = () => {
  // SEO configuration
  useSEO({
    title: "Pack Premium #2 - Galería Exclusiva",
    description: "Accede a galería exclusiva premium",
    keywords: "pack, galería, premium, fotos",
    ogImage: `${BRAND_SITE_URL}/og-pack2.jpg`,
    ogTitle: "Pack Premium #2",
    ogDescription: "Galería exclusiva premium",
    type: "website",
    robots: "noindex, nofollow",
  });

  // Disable body scroll when on pack page
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    const originalHeight = document.body.style.height;
    const originalTouchAction = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100%";
    document.body.style.touchAction = "none";

    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
      document.body.style.height = originalHeight;
      document.body.style.touchAction = originalTouchAction;
      document.documentElement.style.overflow = "";
    };
  }, []);

  // Define your pack content here - ONLY IMAGES
  const packItems: MediaItem[] = [
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&q=80",
      alt: "Foto 1",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800&q=80",
      alt: "Foto 2",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=800&q=80",
      alt: "Foto 3",
    },
    // More images (will be locked behind purchase)
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1496440737103-cd596325d314?w=800&q=80",
      alt: "Foto Exclusiva 1",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&q=80",
      alt: "Foto Exclusiva 2",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=800&q=80",
      alt: "Foto Exclusiva 3",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80",
      alt: "Foto Exclusiva 4",
    },
  ];

  const handlePurchase = () => {
    if (import.meta.env.DEV) {
      console.log("Purchase clicked for Pack2");
    }
    // Add your purchase logic here
  };

  return (
    <ReelsToBuy
      items={packItems}
      maxFreeItems={3}
      price="$14.99"
      packName="Pack Premium #2 - Galería"
      purchaseUrl="/checkout/pack2"
      onPurchaseClick={handlePurchase}
    />
  );
};

export default Pack2;
